import { QueryClient, useQueries } from '@tanstack/react-query';
import { reduce } from 'es-toolkit/compat';
import { isAuthenticationError, isAuthorizationError } from './httpError';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retryDelay: 20 * 1_000, // 20 seconds
      cacheTime: 5 * 60 * 1_000, // 5 minutes
      retry: (failureCount, error) => {
        if (isAuthenticationError(error) || isAuthorizationError(error)) {
          return false;
        }
        // Otherwise, allow retries up to a certain limit
        return failureCount < 3;
      },
    },
  },
});

// hack for now until we migrate to @tanstack/react-query v5 which requires react 18
// see https://github.com/TanStack/query/issues/3049
// also see https://github.com/TanStack/query/issues/5137
export function stabilizedQueriesDependency(queries: ReturnType<typeof useQueries>) {
  return reduce(queries, (acc, cur) => acc + cur.dataUpdatedAt, 0);
}

export default queryClient;
